import { render, staticRenderFns } from "./sensorTabs.vue?vue&type=template&id=2dade19a"
import script from "./sensorTabs.vue?vue&type=script&lang=js"
export * from "./sensorTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports